module.exports = __webpack_public_path__ + "static/img/sqair.c6638bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purifiers/sqair.jpg
// module id = tuUj
// module chunks = 1